// svgo strips viewBox by default, which breaks CSS scaling of the icons
// (they render at their natural size and get cropped/misaligned).
// Jest has no require.context, so under test no SVG is registered and <Icon>
// falls back to an <img>: components that render icons need no Icon mock.
// webpack replaces NODE_ENV at build time and keeps only the require.context branch.
const svgContext =
  process.env.NODE_ENV === 'test'
    ? null
    : require.context(
        '!!@svgr/webpack?{"svgoConfig":{"plugins":[{"removeViewBox":false}]}}!../assets/images',
        true,
        /\.svg$/,
      );

const svgComponents: Record<
  string,
  React.FC<React.SVGProps<SVGSVGElement>>
> = {};

svgContext?.keys().forEach(key => {
  const cleanKey = key.replace('./', '');
  svgComponents[cleanKey] = svgContext(key).default;
});

export const getSvgComponent = (fileName: string) => {
  return svgComponents[fileName] ?? null;
};
